document.addEventListener("DOMContentLoaded", function () {
  const accordionDetails = document.querySelectorAll(".menu-drawer__details");

  accordionDetails.forEach((details) => {
    const summary = details.querySelector("summary");
    const submenu = details.querySelector(".menu-drawer__submenu");
    const plusIcon = summary.querySelector(".svg-wrapper:not(.open-icon)");
    const minusIcon = summary.querySelector(".svg-wrapper.open-icon");

    if (details.hasAttribute("open") && submenu) {
      submenu.style.maxHeight = submenu.scrollHeight + "px";
      plusIcon?.setAttribute("hidden", "true");
      minusIcon?.removeAttribute("hidden");

      updateParentSubmenuHeight(details);
    }

    summary.addEventListener("click", function (e) {
      e.preventDefault();
      const isOpen = details.hasAttribute("open");

      if (isOpen) {
        submenu.style.maxHeight = submenu.scrollHeight + "px"; // 閉じる前に一度高さ固定
        submenu.offsetHeight; // Reflowさせる（ブラウザに認識させる）
        submenu.style.maxHeight = 0;
        details.removeAttribute("open");
        plusIcon?.removeAttribute("hidden");
        minusIcon?.setAttribute("hidden", "true");
      } else {
        details.setAttribute("open", "");
        submenu.style.maxHeight = submenu.scrollHeight + "px";
        plusIcon?.setAttribute("hidden", "true");
        minusIcon?.removeAttribute("hidden");

        updateParentSubmenuHeight(details);
      }
    });

    // transition後にopen解除
    submenu?.addEventListener('transitionend', function () {
      if (!details.hasAttribute('open')) {
        submenu.style.maxHeight = null;
      }
    });
  });

  // 親階層の submenu にも高さを反映させる関数
  function updateParentSubmenuHeight(detailsElement) {
    let parent = detailsElement.parentElement;

    while (parent) {
      if (parent.classList.contains("menu-drawer__submenu")) {
        parent.style.maxHeight = parent.scrollHeight + "px";
      }
      parent = parent.parentElement;
    }
  }
});
document.addEventListener("DOMContentLoaded", function () {
  const toggleButtons = document.querySelectorAll(".js-toggle-button");

  toggleButtons.forEach((button) => {
    button.addEventListener("click", function () {
      const wrapper = button.closest(".js-toggle-description-wrapper");
      const description = wrapper.querySelector(".js-toggle-description");

      const isOpen = description.classList.contains("open");

      if (isOpen) {
        description.style.maxHeight = description.scrollHeight + "px"; // 閉じる前に高さ固定
        description.offsetHeight; // Reflowさせる
        description.style.maxHeight = 0;
        description.classList.remove("open");
        button.textContent = "product details +";
      } else {
        description.classList.add("open");
        description.style.maxHeight = description.scrollHeight + "px";
        button.textContent = "product details -";
      }

      // transitionが終わったらmax-heightリセット
      description.addEventListener('transitionend', function handler() {
        if (description.classList.contains('open')) {
          description.style.maxHeight = 'none';
        }
        description.removeEventListener('transitionend', handler);
      });
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const toggleButtonsSize = document.querySelectorAll(".js-toggle-button-size");

  toggleButtonsSize.forEach((button) => {
    button.addEventListener("click", function () {
      const wrapper = button.closest(".js-toggle-description-wrapper");
      const description = wrapper.querySelector(".js-toggle-description");

      const isOpen = description.classList.contains("open");

      if (isOpen) {
        description.style.maxHeight = description.scrollHeight + "px"; // 閉じる前に高さ固定
        description.offsetHeight; // Reflowさせる
        description.style.maxHeight = 0;
        description.classList.remove("open");
        button.textContent = "sizing chart +";
      } else {
        description.classList.add("open");
        description.style.maxHeight = description.scrollHeight + "px";
        button.textContent = "sizing chart -";
      }

      // transitionが終わったらmax-heightリセット
      description.addEventListener('transitionend', function handler() {
        if (description.classList.contains('open')) {
          description.style.maxHeight = 'none';
        }
        description.removeEventListener('transitionend', handler);
      });
    });
  });
});
/* 
//ひとつ開いたら → 他はとじる
document.addEventListener("DOMContentLoaded", function () {
  const footerItems = document.querySelectorAll(".footer__item.footer__item--links");

  function setupAccordion() {
    if (window.innerWidth <= 999) {
      footerItems.forEach((item) => {
        const title = item.querySelector(".footer__item-title");
        const content = item.querySelector(".footer__item-content");

        // すでにイベントが付いてたら解除
        title.onclick = null;

        title.addEventListener("click", function () {
          const isOpen = item.hasAttribute("open");

          footerItems.forEach((otherItem) => {
            if (otherItem !== item) {
              otherItem.removeAttribute("open");
              const otherContent = otherItem.querySelector(".footer__item-content");
              if (otherContent) {
                otherContent.style.height = null;
              }
            }
          });

          if (isOpen) {
            item.removeAttribute("open");
            content.style.height = null;
          } else {
            item.setAttribute("open", "");
            content.style.height = content.scrollHeight + "px";
          }
        });
      });
    } else {
      // PCサイズではすべてオープンにして高さを解除
      footerItems.forEach((item) => {
        item.setAttribute("open", "");
        const content = item.querySelector(".footer__item-content");
        if (content) {
          content.style.height = "auto";
        }
      });
    }
  }

  setupAccordion();

  window.addEventListener("resize", function () {
    setupAccordion();
  });
});
*/
document.addEventListener("DOMContentLoaded", function () {
  const footerItems = document.querySelectorAll(".footer__item.footer__item--links");

  function setupAccordion() {
    if (window.innerWidth <= 999) {
      footerItems.forEach((item) => {
        const title = item.querySelector(".footer__item-title");
        const content = item.querySelector(".footer__item-content");

        // すでにイベントが付いてたら解除
        title.onclick = null;

        title.addEventListener("click", function () {
          const isOpen = item.hasAttribute("open");

          if (isOpen) {
            item.removeAttribute("open");
            content.style.height = null;
          } else {
            item.setAttribute("open", "");
            content.style.height = content.scrollHeight + "px";
          }
        });
      });
    } else {
      // PCサイズではすべてオープンにして高さを解除
      footerItems.forEach((item) => {
        item.setAttribute("open", "");
        const content = item.querySelector(".footer__item-content");
        if (content) {
          content.style.height = "auto";
        }
      });
    }
  }

  setupAccordion();

  window.addEventListener("resize", function () {
    setupAccordion();
  });
});